import { Box } from '@mui/material';
import { useState } from 'react';

export default function ProfileForm({ onSubmit, children }) {
    const [isEditable, setIsEditable] = useState(false);

    return (
        <Box
            component="form"
            onSubmit={onSubmit}
        >
            {children(isEditable)}

            {/* <Box marginTop={2}>
                <Button
                    variant="contained"
                    onClick={() => setIsEditable(val => !val)}
                >
                    {!isEditable ? 'Edit' : 'Save'}
                </Button>

                {isEditable && (
                    <Button
                        variant="contained"
                        onClick={() => setIsEditable(false)}
                        color="error"
                    >
                        Cancel
                    </Button>
                )}
            </Box> */}
        </Box>
    );
}
